<template>
  <div class="not-found">
    <div class="content">
      <h1 class="title">Erreur 404</h1>
      <p class="subtitle">La page que vous cherchez n'est pas disponible ou n'existe plus</p>
      <router-link to="/" active-class="">
        <span class="inner">retourner à l'accueil</span>
      </router-link>
    </div>
    <video autoplay loop muted playsinline class="video" src="/static/404.mp4"></video>
  </div>
</template>


<script>
export default {
  name: 'not-found',

  methods: {
    enter(done) {
      TweenMax.from(this.$el, 0.6, {
        autoAlpha: 0,
        ease: Quart.easeOut,
        force3D: true,
        onComplete: done
      });
    },
    leave(done) {
      TweenMax.to(this.$el, 0.4, {
        autoAlpha: 0,
        ease: Quart.easeOut,
        force3D: true,
        onComplete: done
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~include-media/dist/_include-media.scss';

.not-found {
  min-height: calc(100vh - 156px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @include media('<1440px') {
    min-height: calc(100vh - 125px);
  }
}

.video {
  position: absolute;
  width: 100vw;
  height: 120vh;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  object-fit: cover;
  z-index: 0;

  @include media('<=tablet') {
    display: none;
  }
}

.content {
  position: relative;
  text-align: center;
  z-index: 10;
  margin-bottom: 156px;

  @include media('<1440px') {
    margin-bottom: 125px;
  }

  @include media('<=tablet') {
    margin-bottom: 84px;
  }
}

.title {
  margin: 0;
  text-transform: lowercase;
  font-size: 72px;
  line-height: 1.1;
}

.subtitle {
  margin: 16px 0 28px;
}

@include media('<=tablet') {
  .title {
    font-size: 54px;
  }

  .subtitle {
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// NotFound.vue?05803c29